import React from 'react';
// import { NavLink } from "react-router-dom";

import './footer.css';

// import logo from '../../assets/images/logo.jpg'
import mail from '../../assets/images/icon-mail2.svg'
import insta from '../../assets/images/icon-ig.svg'
import phone from '../../assets/images/icon-phone.svg'
import snapicone from '../../assets/images/snapicone.png'


const Footer = () => {
    return (
        <footer id="contact" className="footer">
        { /* TODO: link dans le footer a voir ..
        
        <div className="footer-link">
                <ul className="nav__links footer-links">
                    <li>
                        <NavLink exact to="/">ACCUEIL</NavLink>
                    </li>
                    <li>
                        <NavLink to="/baby-shower">BABY SHOWER</NavLink>
                    </li>
                    <li>
                        <NavLink to="/anniversaire">ANNIVERSAIRE</NavLink>
                    </li>
                    <li>
                        <NavLink to="/mariage">MARIAGE</NavLink>
                    </li>
                </ul>
            </div>
            */
        }
            
            <div className="footer-contact">
                <h3>CONTACT</h3>
                <p>
                    <span><img className="icon icon-mail" src={mail} alt="icon-mail"/></span>
                    <a href="mailto:lesdelicesdelylia@gmail.com?subject=Mail from Our Site">lesdelicesdelylia@gmail.com</a>
                </p>
                <p>
                    <span><img className="icon icon-ig" src={insta} alt="icon-ig"/></span>
                    <a href="https://www.instagram.com/les_delices_de_lylia/?igshid=x9kghvw1tu1" target="_blank" rel="noreferrer" >Les delices de lylia
</a>
                </p>
                <p>
                    <span><img className="icon icon-phone" src={phone} alt="icon-phone"/></span>
                    <a href="tel:07.62.38.06.10"> 07.62.38.06.10</a>
                </p>
                <p>
                    <span><img className="icon icon-phone" src={snapicone} alt="icon-phone"/></span>
                    <span> lyliadu59</span>
                </p>
            </div>
        </footer>
    );
};
export default Footer;